import { createAsyncThunk } from '@reduxjs/toolkit';

import { getCreatorAudience } from '../../../../../ajax';
import { AudienceData, SLICE_NAME } from './types';

export const fetchCreatorAudience = createAsyncThunk<AudienceData>(
  `${SLICE_NAME}/fetchCreatorAudience`,
  () => getCreatorAudience()
);
